module.exports = __webpack_public_path__ + "img/qrcode1.d9134bc7.png";